import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { ResourceIdentifiers } from '@repo/api-gw-sdk';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
export const ResourceIdentifierItem = t0 => {
  const $ = _c(11);
  const {
    resource
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== resource.providerId) {
    t2 = <OverflowTooltip shouldCloseOnScroll={true} text={resource.providerId} renderContent={_temp} />;
    $[1] = resource.providerId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== resource.id) {
    t3 = (text_0, ref_0) => <Typography variant="body2" className="truncate" ref={ref_0} sx={{
      color: !resource.id ? "var(--mui-palette-info-main)" : undefined
    }}>{text_0}</Typography>;
    $[3] = resource.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== resource.name || $[6] !== t3) {
    t4 = <OverflowTooltip shouldCloseOnScroll={true} text={resource.name} renderContent={t3} />;
    $[5] = resource.name;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Stack className="truncate" sx={t1}>{t2}{t4}</Stack>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(text, ref) {
  return <Typography variant="subtitle1" className="truncate" ref={ref}>{text}</Typography>;
}